<div class="card card-container" [ngClass]="cardClass" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseExit()">
    <div class="card-body">
        <div class="more-icons">
            <i class="fa fa-times" [hidden]="!showComplete || !isHover" (click)="completeTimer()"
                title="Complete Timer"></i>
        </div>

        <div class="card-left" (click)="click()">
            <dw-image [src]="employeeImageUrl" maxWidth="150px" maxHeight="150px"
                [defaultSrc]="defaultImageUrl"></dw-image>
        </div>
        <div class="card-right">
            <div class="timer-card-title-info" (click)="click()" [title]="titleTooltip" [hidden]="!titleTooltip">
                {{titleDisplay}} <i class="fa fa-calendar dw-blue" title="View Calendar in Trust" (click)="openWindow(this.trustCalendarUrl, $event)"></i>
            </div>
            <div class="timer-card-title-info" (click)="click()" [title]="titleTooltip" [hidden]="titleTooltip">
                {{titleDisplay}}  <i class="fa fa-calendar  dw-blue" title="View Calendar in Trust" (click)="openWindow(this.trustCalendarUrl, $event)"></i>
            </div>
            <div class="timer-card-date-info" (click)="click()">
                <div>
                    <span>{{cityState}}</span>
                    <span title="Current Week Hours" class="ml-2 hour-text">
                        <i class="fa fa-clock"></i> {{data?.EthosLaborMetricsHoursCurrentWeek || 0 }}hrs
                    </span>
                    <span title="Last Week Hours" class="ml-1 hour-text">
                        <i class="fa fa-history"></i> {{data?.EthosLaborMetricsHoursLastWeek || 0 }}hrs
                    </span>
                </div>
                <div class="skills" title="Skills: {{data?.TechEthosRoUserSkillListTimerSkillList || 'None'}}">
                   <!--<span title="Skills: {{data?.TechEthosRoUserSkillListTimerSkillList || 'None'}}" class="ml-1 text-ellipsis">-->
                        <i class="fa fa-forklift"></i>
                         {{data?.TechEthosRoUserSkillListTimerSkillList || 'No Skills'}}
                    <!--</span>-->
                </div>
            </div> 
            <div class="timer">
                <span (click)="click()">
                    {{ timeLeftDisplay }} 
                </span>
                <span class="control-buttons" [hidden]="!isHover || buttonVisibility?.hideButtons">
                    <i class="fa fa-play mr-1" (click)="start()" [hidden]="!buttonVisibility?.showStart" title="Start Timer"></i>
                    <i class="fa fa-stop mr-1" (click)="stop()" [hidden]="!buttonVisibility?.showStop" title="Stop Timer" ></i>
                    <i class="fa fa-redo"  (click)="reset()" [hidden]="!buttonVisibility?.showReset" title="Reset"></i>
                </span>
            </div>
           <div class="notes" [hidden]="!notes" [title]="notes">
                {{notes}}
           </div>
        </div>
    </div>
</div>  